module.exports = __webpack_public_path__ + "static/media/furniture-6.eb294168.jpg";